import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { PageZoppmDraft } from '../models';
// @ts-ignore
import { PageZoppmMojeResponse } from '../models';
// @ts-ignore
import { PageZoppmPodpisovatelResponse } from '../models';
// @ts-ignore
import { ValidacnaSprava } from '../models';
// @ts-ignore
import { ZoppmDraftCreateRequest } from '../models';
// @ts-ignore
import { ZoppmDraftDetailResponse } from '../models';
// @ts-ignore
import { ZoppmDraftPrilohaResponse } from '../models';
// @ts-ignore
import { ZoppmDraftUpdateRequest } from '../models';
// @ts-ignore
import { ZoppmMojZoznamResponse } from '../models';
/**
 * ZoppmDraftApi - axios parameter creator
 * @export
 */
export const ZoppmDraftApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create zoppm draft
         * @summary create zoppm draft
         * @param {ZoppmDraftCreateRequest} zoppmDraftCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZoppmDraftZoppmDraft: async (zoppmDraftCreateRequest: ZoppmDraftCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftCreateRequest' is not null or undefined
            assertParamExists('createZoppmDraftZoppmDraft', 'zoppmDraftCreateRequest', zoppmDraftCreateRequest)
            const localVarPath = `/zoppm-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zoppmDraftCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete single priloha by zoppmDraftKod
         * @summary delete priloha by zoppmDraftKod
         * @param {string} zoppmDraftKod 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContentOfDokumentForZoppmDraftZoppmDraft: async (zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('deleteContentOfDokumentForZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            // verify required parameter 'identifikatorUlozisko' is not null or undefined
            assertParamExists('deleteContentOfDokumentForZoppmDraftZoppmDraft', 'identifikatorUlozisko', identifikatorUlozisko)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}/prilohy/dokumenty`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (identifikatorUlozisko !== undefined) {
                localVarQueryParameter['identifikatorUlozisko'] = identifikatorUlozisko;
            }

            if (verziaUlozisko !== undefined) {
                localVarQueryParameter['verziaUlozisko'] = verziaUlozisko;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete zoppm draft
         * @summary delete zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteZoppmDraftZoppmDraft: async (zoppmDraftKod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('deleteZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zoznam možných podpisovateľov pre subjekt
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAvailablePodpisovatelListZoppmDraft: async (rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zoppm-draft/available-podpisovatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (rsql !== undefined) {
                localVarQueryParameter['rsql'] = rsql;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find single priloha by zoppmDraftKod
         * @summary get priloha by zoppmDraftKod
         * @param {string} zoppmDraftKod 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {string} [responseContentType] 
         * @param {string} [responseContentDisposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForZoppmDraftZoppmDraft: async (zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('fetchContentOfDokumentForZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            // verify required parameter 'identifikatorUlozisko' is not null or undefined
            assertParamExists('fetchContentOfDokumentForZoppmDraftZoppmDraft', 'identifikatorUlozisko', identifikatorUlozisko)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}/prilohy/dokumenty`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (identifikatorUlozisko !== undefined) {
                localVarQueryParameter['identifikatorUlozisko'] = identifikatorUlozisko;
            }

            if (verziaUlozisko !== undefined) {
                localVarQueryParameter['verziaUlozisko'] = verziaUlozisko;
            }

            if (responseContentType !== undefined) {
                localVarQueryParameter['responseContentType'] = responseContentType;
            }

            if (responseContentDisposition !== undefined) {
                localVarQueryParameter['responseContentDisposition'] = responseContentDisposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * finalize zoppm draft
         * @summary finalize zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeZoppmDraftZoppmDraft: async (zoppmDraftKod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('finalizeZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}/finalizacia`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find zoppm draft list
         * @summary find zoppm drafts
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllZoppmDraftsZoppmDraft: async (rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zoppm-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (rsql !== undefined) {
                localVarQueryParameter['rsql'] = rsql;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zoznam podpisovateľov pre subjekt
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultPodpisovateliaListZoppmDraft: async (page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zoppm-draft/default-podpisovatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find zoppm draft by kod
         * @summary get my zoppm
         * @param {string} zoppmKod 
         * @param {string} [casOdoslania] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmByKodZoppmDraft: async (zoppmKod: string, casOdoslania?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmKod' is not null or undefined
            assertParamExists('getMyZoppmByKodZoppmDraft', 'zoppmKod', zoppmKod)
            const localVarPath = `/zoppm-draft/moje-ziadosti/{zoppmKod}`
                .replace(`{${"zoppmKod"}}`, encodeURIComponent(String(zoppmKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (casOdoslania !== undefined) {
                localVarQueryParameter['casOdoslania'] = casOdoslania;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zoznam rozpracovaných žiadostí vytvorených subjektom filtrovaných podľa výzvy
         * @param {string} vyzvaId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmDraftListByVyzvaZoppmDraft: async (vyzvaId: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('getMyZoppmDraftListByVyzvaZoppmDraft', 'vyzvaId', vyzvaId)
            const localVarPath = `/zoppm-draft/{vyzvaId}/moje-rozpracovane-ziadosti`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zoznam žiadostí vytvorených subjektom
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmListZoppmDraft: async (rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zoppm-draft/moje-ziadosti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (rsql !== undefined) {
                localVarQueryParameter['rsql'] = rsql;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find zoppm draft by kod
         * @summary find zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoppmDraftByKodZoppmDraft: async (zoppmDraftKod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('getZoppmDraftByKodZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * store <dokument> for zoppm draft 
         * @summary store <dokument> for zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeDokumentForZoppmDraftZoppmDraft: async (zoppmDraftKod: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('storeDokumentForZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('storeDokumentForZoppmDraftZoppmDraft', 'file', file)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}/prilohy/dokumenty`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update zoppm draft
         * @summary update zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {ZoppmDraftUpdateRequest} zoppmDraftUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoppmDraftZoppmDraft: async (zoppmDraftKod: string, zoppmDraftUpdateRequest: ZoppmDraftUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('updateZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            // verify required parameter 'zoppmDraftUpdateRequest' is not null or undefined
            assertParamExists('updateZoppmDraftZoppmDraft', 'zoppmDraftUpdateRequest', zoppmDraftUpdateRequest)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zoppmDraftUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * validate zoppm draft
         * @summary validate zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateZoppmDraftZoppmDraft: async (zoppmDraftKod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmDraftKod' is not null or undefined
            assertParamExists('validateZoppmDraftZoppmDraft', 'zoppmDraftKod', zoppmDraftKod)
            const localVarPath = `/zoppm-draft/{zoppmDraftKod}/validacia`
                .replace(`{${"zoppmDraftKod"}}`, encodeURIComponent(String(zoppmDraftKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoppmDraftApi - functional programming interface
 * @export
 */
export const ZoppmDraftApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoppmDraftApiAxiosParamCreator(configuration)
    return {
        /**
         * create zoppm draft
         * @summary create zoppm draft
         * @param {ZoppmDraftCreateRequest} zoppmDraftCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createZoppmDraftZoppmDraft(zoppmDraftCreateRequest: ZoppmDraftCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmDraftDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createZoppmDraftZoppmDraft(zoppmDraftCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete single priloha by zoppmDraftKod
         * @summary delete priloha by zoppmDraftKod
         * @param {string} zoppmDraftKod 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, identifikatorUlozisko, verziaUlozisko, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete zoppm draft
         * @summary delete zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteZoppmDraftZoppmDraft(zoppmDraftKod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zoznam možných podpisovateľov pre subjekt
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAvailablePodpisovatelListZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageZoppmPodpisovatelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAvailablePodpisovatelListZoppmDraft(rsql, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find single priloha by zoppmDraftKod
         * @summary get priloha by zoppmDraftKod
         * @param {string} zoppmDraftKod 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {string} [responseContentType] 
         * @param {string} [responseContentDisposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, identifikatorUlozisko, verziaUlozisko, responseContentType, responseContentDisposition, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * finalize zoppm draft
         * @summary finalize zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmDraftDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeZoppmDraftZoppmDraft(zoppmDraftKod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find zoppm draft list
         * @summary find zoppm drafts
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllZoppmDraftsZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageZoppmDraft>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllZoppmDraftsZoppmDraft(rsql, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zoznam podpisovateľov pre subjekt
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultPodpisovateliaListZoppmDraft(page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageZoppmPodpisovatelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultPodpisovateliaListZoppmDraft(page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find zoppm draft by kod
         * @summary get my zoppm
         * @param {string} zoppmKod 
         * @param {string} [casOdoslania] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyZoppmByKodZoppmDraft(zoppmKod: string, casOdoslania?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmMojZoznamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyZoppmByKodZoppmDraft(zoppmKod, casOdoslania, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zoznam rozpracovaných žiadostí vytvorených subjektom filtrovaných podľa výzvy
         * @param {string} vyzvaId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyZoppmDraftListByVyzvaZoppmDraft(vyzvaId: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageZoppmMojeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyZoppmDraftListByVyzvaZoppmDraft(vyzvaId, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zoznam žiadostí vytvorených subjektom
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyZoppmListZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageZoppmMojeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyZoppmListZoppmDraft(rsql, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find zoppm draft by kod
         * @summary find zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoppmDraftByKodZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmDraftDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoppmDraftByKodZoppmDraft(zoppmDraftKod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * store <dokument> for zoppm draft 
         * @summary store <dokument> for zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmDraftPrilohaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update zoppm draft
         * @summary update zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {ZoppmDraftUpdateRequest} zoppmDraftUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZoppmDraftZoppmDraft(zoppmDraftKod: string, zoppmDraftUpdateRequest: ZoppmDraftUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmDraftDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateZoppmDraftZoppmDraft(zoppmDraftKod, zoppmDraftUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * validate zoppm draft
         * @summary validate zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidacnaSprava>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateZoppmDraftZoppmDraft(zoppmDraftKod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoppmDraftApi - factory interface
 * @export
 */
export const ZoppmDraftApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoppmDraftApiFp(configuration)
    return {
        /**
         * create zoppm draft
         * @summary create zoppm draft
         * @param {ZoppmDraftCreateRequest} zoppmDraftCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZoppmDraftZoppmDraft(zoppmDraftCreateRequest: ZoppmDraftCreateRequest, options?: any): AxiosPromise<ZoppmDraftDetailResponse> {
            return localVarFp.createZoppmDraftZoppmDraft(zoppmDraftCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * delete single priloha by zoppmDraftKod
         * @summary delete priloha by zoppmDraftKod
         * @param {string} zoppmDraftKod 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, identifikatorUlozisko, verziaUlozisko, options).then((request) => request(axios, basePath));
        },
        /**
         * delete zoppm draft
         * @summary delete zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteZoppmDraftZoppmDraft(zoppmDraftKod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zoznam možných podpisovateľov pre subjekt
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAvailablePodpisovatelListZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageZoppmPodpisovatelResponse> {
            return localVarFp.fetchAvailablePodpisovatelListZoppmDraft(rsql, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * find single priloha by zoppmDraftKod
         * @summary get priloha by zoppmDraftKod
         * @param {string} zoppmDraftKod 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {string} [responseContentType] 
         * @param {string} [responseContentDisposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options?: any): AxiosPromise<string> {
            return localVarFp.fetchContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, identifikatorUlozisko, verziaUlozisko, responseContentType, responseContentDisposition, options).then((request) => request(axios, basePath));
        },
        /**
         * finalize zoppm draft
         * @summary finalize zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: any): AxiosPromise<ZoppmDraftDetailResponse> {
            return localVarFp.finalizeZoppmDraftZoppmDraft(zoppmDraftKod, options).then((request) => request(axios, basePath));
        },
        /**
         * find zoppm draft list
         * @summary find zoppm drafts
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllZoppmDraftsZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageZoppmDraft> {
            return localVarFp.getAllZoppmDraftsZoppmDraft(rsql, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zoznam podpisovateľov pre subjekt
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultPodpisovateliaListZoppmDraft(page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageZoppmPodpisovatelResponse> {
            return localVarFp.getDefaultPodpisovateliaListZoppmDraft(page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Find zoppm draft by kod
         * @summary get my zoppm
         * @param {string} zoppmKod 
         * @param {string} [casOdoslania] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmByKodZoppmDraft(zoppmKod: string, casOdoslania?: string, options?: any): AxiosPromise<ZoppmMojZoznamResponse> {
            return localVarFp.getMyZoppmByKodZoppmDraft(zoppmKod, casOdoslania, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zoznam rozpracovaných žiadostí vytvorených subjektom filtrovaných podľa výzvy
         * @param {string} vyzvaId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmDraftListByVyzvaZoppmDraft(vyzvaId: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageZoppmMojeResponse> {
            return localVarFp.getMyZoppmDraftListByVyzvaZoppmDraft(vyzvaId, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zoznam žiadostí vytvorených subjektom
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmListZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageZoppmMojeResponse> {
            return localVarFp.getMyZoppmListZoppmDraft(rsql, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Find zoppm draft by kod
         * @summary find zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoppmDraftByKodZoppmDraft(zoppmDraftKod: string, options?: any): AxiosPromise<ZoppmDraftDetailResponse> {
            return localVarFp.getZoppmDraftByKodZoppmDraft(zoppmDraftKod, options).then((request) => request(axios, basePath));
        },
        /**
         * store <dokument> for zoppm draft 
         * @summary store <dokument> for zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, file: any, options?: any): AxiosPromise<ZoppmDraftPrilohaResponse> {
            return localVarFp.storeDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, file, options).then((request) => request(axios, basePath));
        },
        /**
         * update zoppm draft
         * @summary update zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {ZoppmDraftUpdateRequest} zoppmDraftUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoppmDraftZoppmDraft(zoppmDraftKod: string, zoppmDraftUpdateRequest: ZoppmDraftUpdateRequest, options?: any): AxiosPromise<ZoppmDraftDetailResponse> {
            return localVarFp.updateZoppmDraftZoppmDraft(zoppmDraftKod, zoppmDraftUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * validate zoppm draft
         * @summary validate zoppm draft
         * @param {string} zoppmDraftKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: any): AxiosPromise<Array<ValidacnaSprava>> {
            return localVarFp.validateZoppmDraftZoppmDraft(zoppmDraftKod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoppmDraftApi - object-oriented interface
 * @export
 * @class ZoppmDraftApi
 * @extends {BaseAPI}
 */
export class ZoppmDraftApi extends BaseAPI {
    /**
     * create zoppm draft
     * @summary create zoppm draft
     * @param {ZoppmDraftCreateRequest} zoppmDraftCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public createZoppmDraftZoppmDraft(zoppmDraftCreateRequest: ZoppmDraftCreateRequest, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).createZoppmDraftZoppmDraft(zoppmDraftCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete single priloha by zoppmDraftKod
     * @summary delete priloha by zoppmDraftKod
     * @param {string} zoppmDraftKod 
     * @param {string} identifikatorUlozisko 
     * @param {string} [verziaUlozisko] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public deleteContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).deleteContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, identifikatorUlozisko, verziaUlozisko, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete zoppm draft
     * @summary delete zoppm draft
     * @param {string} zoppmDraftKod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public deleteZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).deleteZoppmDraftZoppmDraft(zoppmDraftKod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zoznam možných podpisovateľov pre subjekt
     * @param {string} [rsql] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public fetchAvailablePodpisovatelListZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).fetchAvailablePodpisovatelListZoppmDraft(rsql, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find single priloha by zoppmDraftKod
     * @summary get priloha by zoppmDraftKod
     * @param {string} zoppmDraftKod 
     * @param {string} identifikatorUlozisko 
     * @param {string} [verziaUlozisko] 
     * @param {string} [responseContentType] 
     * @param {string} [responseContentDisposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public fetchContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).fetchContentOfDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, identifikatorUlozisko, verziaUlozisko, responseContentType, responseContentDisposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * finalize zoppm draft
     * @summary finalize zoppm draft
     * @param {string} zoppmDraftKod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public finalizeZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).finalizeZoppmDraftZoppmDraft(zoppmDraftKod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find zoppm draft list
     * @summary find zoppm drafts
     * @param {string} [rsql] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public getAllZoppmDraftsZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).getAllZoppmDraftsZoppmDraft(rsql, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zoznam podpisovateľov pre subjekt
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public getDefaultPodpisovateliaListZoppmDraft(page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).getDefaultPodpisovateliaListZoppmDraft(page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find zoppm draft by kod
     * @summary get my zoppm
     * @param {string} zoppmKod 
     * @param {string} [casOdoslania] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public getMyZoppmByKodZoppmDraft(zoppmKod: string, casOdoslania?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).getMyZoppmByKodZoppmDraft(zoppmKod, casOdoslania, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zoznam rozpracovaných žiadostí vytvorených subjektom filtrovaných podľa výzvy
     * @param {string} vyzvaId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public getMyZoppmDraftListByVyzvaZoppmDraft(vyzvaId: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).getMyZoppmDraftListByVyzvaZoppmDraft(vyzvaId, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zoznam žiadostí vytvorených subjektom
     * @param {string} [rsql] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public getMyZoppmListZoppmDraft(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).getMyZoppmListZoppmDraft(rsql, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find zoppm draft by kod
     * @summary find zoppm draft
     * @param {string} zoppmDraftKod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public getZoppmDraftByKodZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).getZoppmDraftByKodZoppmDraft(zoppmDraftKod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * store <dokument> for zoppm draft 
     * @summary store <dokument> for zoppm draft
     * @param {string} zoppmDraftKod 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public storeDokumentForZoppmDraftZoppmDraft(zoppmDraftKod: string, file: any, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).storeDokumentForZoppmDraftZoppmDraft(zoppmDraftKod, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update zoppm draft
     * @summary update zoppm draft
     * @param {string} zoppmDraftKod 
     * @param {ZoppmDraftUpdateRequest} zoppmDraftUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public updateZoppmDraftZoppmDraft(zoppmDraftKod: string, zoppmDraftUpdateRequest: ZoppmDraftUpdateRequest, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).updateZoppmDraftZoppmDraft(zoppmDraftKod, zoppmDraftUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * validate zoppm draft
     * @summary validate zoppm draft
     * @param {string} zoppmDraftKod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoppmDraftApi
     */
    public validateZoppmDraftZoppmDraft(zoppmDraftKod: string, options?: AxiosRequestConfig) {
        return ZoppmDraftApiFp(this.configuration).validateZoppmDraftZoppmDraft(zoppmDraftKod, options).then((request) => request(this.axios, this.basePath));
    }
}
